import Card from './Card';
import '../styles/Containers.css';
import { Link } from 'react-router-dom';

function OneCategory(props) {
  const { title, tagHref, foods } = props;

  return (
    <div className="category">
      <div className="spc-between">
        <p className="heading-2">{title}</p>
        <Link to={`/tags/${tagHref}`} href={tagHref} className="caption-1 purple-1 marginL5">
          دیدن همه
        </Link>
      </div>
      <div className="card-row">
        {foods.map((card) => {
          return <Card card={card} key={card.recipe_id} />;
        })}
      </div>
    </div>
  );
}

export default OneCategory;
